import * as React from 'react';
import { Button } from '../button';
import { useCarousel } from './carousel';
import type { SyntheticEvent } from 'react';
import { cn } from '../../utils/cn';
interface CarouselPreviousProps extends React.PropsWithChildren {}

export const CarouselPrevious = (
    props: CarouselPreviousProps & React.ComponentProps<typeof Button>,
) => {
    const {
        children,
        color = 'secondary',
        size = 'square40',
        // The corner comes from `--radius-btn-m` in the class below, so the
        // shape variant stays the library default and the flag-off render is
        // the disc it has always been.
        shape = 'default',
        inverted = false,
        className,
    } = props;

    const { scrollPrev, canScrollPrev, canScrollNext } = useCarousel();
    const enableScroll = canScrollPrev || canScrollNext;

    const onScrollPrev = (evt: SyntheticEvent) => {
        evt.preventDefault();
        evt.stopPropagation();
        scrollPrev();
    };

    return enableScroll ? (
        <div className="rocco-carousel-previous z-20 flex items-center justify-center">
            <Button
                color={color}
                size={size}
                shape={shape}
                inverted={inverted}
                onClick={onScrollPrev}
                className={cn(
                    'rounded-[var(--radius-btn-m)]',
                    // 'transition-opacity duration-200',
                    !canScrollPrev && 'pointer-events-auto opacity-50',
                    className,
                )}
            >
                {children}
                <span className="sr-only">Previous slide</span>
            </Button>
        </div>
    ) : null;
};
